import { useReviewCheckToggleContext } from '#baseMenu/components';
import { useAdvertReviewCheckVisibleControl } from '#reviewCheck/hooks';

const useReviewCheckHandlerClick = () => {
  const {
    isOpen: isOpenReviewCheck,
    open,
    hide,
  } = useAdvertReviewCheckVisibleControl();
  const {
    ReviewCheck,
    isLoaded,
    setIsLoaded,
    setIsLoadInProcess,
  } = useReviewCheckToggleContext();

  return () => {
    if (!isLoaded) {
      setIsLoadInProcess(true);
      ReviewCheck.load().then(() => {
        setIsLoaded(true);
        setTimeout(() => {
          setIsLoadInProcess(false);
          open();
        }, 1);
      });
      return;
    }

    if (isOpenReviewCheck) {
      hide();
    } else {
      open();
    }
  };
};

export { useReviewCheckHandlerClick };
